module.exports = __webpack_public_path__ + "fonts/Jost-400-Book.9d6c1a5.otf";